import FetchHelper from '../helpers/fetch_helper';
import Config from '../config/config';

const TRACE_LEVEL = { type: 'TRACE', value: 1000 };
const DEBUG_LEVEL = { type: 'DEBUG', value: 2000 };
const INFO_LEVEL = { type: 'INFO', value: 3000 };
const WARN_LEVEL = { type: 'WARN', value: 4000 };
const ERROR_LEVEL = { type: 'ERROR', value: 5000 };
const FATAL_LEVEL = { type: 'FATAL', value: 6000 };

async function log(level, message, error) {
  const timestamp = new Date();

  if (level.value >= INFO_LEVEL.value || Config.debug) {
    consoleLog(timestamp, level, message, error);
  }

  if (level.value >= WARN_LEVEL.value) {
    try {
      await FetchHelper.fetchJson('logs', {
        method: 'POST',
        body: {
          clientTimestamp: timestamp,
          level: level.type,
          message,
          error,
        },
      });
    } catch (e) {
      let logError = null;
      if (e && e.response) {
        logError = await e.response.text();
      }

      consoleLog(timestamp, ERROR_LEVEL, 'Writing log to server failed', logError);
    }
  }
}

function consoleLog(timestamp, level, message, error) {
  /* eslint-disable no-console */
  if (error) {
    console.log(`${timestamp.toISOString()} ${level.type}: `, message, error);
  } else {
    console.log(`${timestamp.toISOString()} ${level.type}: `, message);
  }
  /* eslint-enable no-console */
}

const Log = {
  async trace(message, error) {
    await log(TRACE_LEVEL, message, error);
  },

  async debug(message, error) {
    await log(DEBUG_LEVEL, message, error);
  },

  async info(message, error) {
    await log(INFO_LEVEL, message, error);
  },

  async warn(message, error) {
    await log(WARN_LEVEL, message, error);
  },

  async error(message, error) {
    await log(ERROR_LEVEL, message, error);
  },

  async fatal(message, error) {
    await log(FATAL_LEVEL, message, error);
  },
};
export default Log;
